import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SideBarService} from '@services/side-bar/side-bar.service';
import {TranslateService} from '@ngx-translate/core';
import {Location} from '@angular/common';
import {Title} from '@angular/platform-browser';
import {EnvironmentConfig} from '@environments/environment';
import {ScrollService} from './shared/scroll-service/scroll.service';
import {AuthenticationRedirectService} from '@services/user/authentication-redirect.service';

@Component({
    selector: 'scitis-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  private LOGIN_URL_SUFFIX: string = '#/login';
  private SSO_URL_SUFFIX: string = '#/samllogin';
  private AGREEMENT_URL_SUFFIX: string = '#/agreement';
  private RESET_PASSWORD_URL_CONTENT: string = '/authorization/resetPassword';
  private sidebarStatusKey = '';

  showHeaderAndSidebar: boolean = false;

  @ViewChild('mainView') mainView: ElementRef | undefined;

  constructor(private titleService: Title,
              translate: TranslateService,
              private location: Location,
              private sideBarService: SideBarService,
              private scrollService: ScrollService,
              private authenticationRedirectService: AuthenticationRedirectService) {
    this.authenticationRedirectService.captureExternalRedirect(window.location.href);
    this.location.onUrlChange(x => this.urlChange(x));
    this.titleService.setTitle(EnvironmentConfig.PortalSettings.portalTitle);
    if (!EnvironmentConfig.productionMode) {
      (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = EnvironmentConfig.firebase.debugToken;
    }
  }

  get isSidebarOpen(): boolean {
    return this.sideBarService.isSidebarOpen;
  }
  
  ngOnInit(): void {
    this.initSubscription();
  }

  public initSubscription(): void {
    this.scrollService.getPosition().subscribe((y) => {
      this.scrollTo(y);
    });
  }

  public scrollTo(positionY: number): void {
    if (this.mainView?.nativeElement) {
      this.mainView?.nativeElement.scroll({
        top: positionY,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  urlChange(url: string) {
    this.showHeaderAndSidebar = !(url === this.LOGIN_URL_SUFFIX || url === this.AGREEMENT_URL_SUFFIX || url === this.SSO_URL_SUFFIX || url.includes(this.RESET_PASSWORD_URL_CONTENT));
  }

  setSidebarStatusKey(sidebarStatusKey: string): void {
    this.sidebarStatusKey = sidebarStatusKey;
  }

  closeMobileDimmer(): void {
    this.sideBarService.toggleSidebar(this.sidebarStatusKey);
    this.sideBarService.closeMobileDimmer(this.sidebarStatusKey, this.isSidebarOpen);
  }
}
